import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #70737c38;
  gap: 16px;
  padding: 16px;
`;

export const SelectedChipBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow-x: auto;
  gap: 8px;
`;

export const SelectedChip = styled.div`
  padding: 4px 8px;
  border-radius: 9999px;
  border: 1px solid #e1e2e4;
  background-color: #70737c0d;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: nowrap;

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

export const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const ResetButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #70737c38;
  background-color: #fff;
  font-size: 10px;
  font-weight: 500;
  color: #37383c9c;
  cursor: pointer;
  padding: 7px 16px;
`;

export const CancleButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #70737c38;
  background-color: #fff;
  font-size: 16px;
  font-weight: 500;
  color: #37383c9c;
  cursor: pointer;
  padding: 14px 16px;
`;

export const ApplyButton = styled.button`
  flex: 1;
  border-radius: 8px;
  border: none;
  padding: 14px 28px;
  background-color: #008aff;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
`;
